import Vue from "vue";
import VueRouter from "vue-router";
import { getUsuarioLogado } from "@/db/usuario";
import storeUsuario from "../store/usuario";
import storeSistema from "../store/sistema";
import HomeView from "../views/home/HomeView.vue";
import sistemaRouter from "./sistemaRouter";
import clientesRouter from "./clientesRouter";
import pedidosRouter from "./pedidosRouter";
import relatoriosRouter from "./relatoriosRouter";
import formacaoCargaRouter from "./formacaoCargaRouter";
import { getSincronizacoes } from "@/db/sistema";
import PaginaNaoEncontrada from "@/views/errors/PaginaNaoEncontrada";
// import pedidosStore from "@/store/pedidos"; // <-- Não precisamos mais disso aqui
import store from "@/store";
import visitaTecnicaRouter from "./visitaTecnicaRouter";

Vue.use(VueRouter);

const baseRoutes = [
  {
    path: "/",
    name: "Coasul - Nutrição Animal",
    component: HomeView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false,
    },
  },
  {
    path: "*",
    name: "Coasul - 404",
    component: PaginaNaoEncontrada,
    meta: {
      requiresAuth: true,
      sync: false,
      online: false,
    },
  },
];

const routes = baseRoutes.concat(
  sistemaRouter,
  clientesRouter,
  pedidosRouter,
  relatoriosRouter,
  formacaoCargaRouter,
  visitaTecnicaRouter
);

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Liga o loading ao iniciar a transição
  storeSistema.state.loadingApp = true;

  try {
    var userLogado = await getUsuarioLogado();
    storeUsuario.mutations.setUsuarioLogado(storeUsuario.state, userLogado);

    // --- ROTA EXIGE AUTENTICAÇÃO ---
    if (to.meta.requiresAuth) {
      
      // 1. Sem usuário logado -> Login
      if (userLogado == null) {
        storeSistema.state.loadingApp = false;
        return next("/login"); // 'return' para parar a execução aqui
      } 
      
      // 2. Com usuário -> Verificações
      else {
        if (navigator.onLine) {
          storeSistema.actions.validarToken(storeSistema.getters);
          
          // ❌ REMOVIDO: Sincronização de pedidos.
          // Agora isso acontece no 'mounted' do App.vue em background.
        }

        // 3. Verificação de Sync Obrigatório
        if (to.meta.sync) {
          var listaSync = await getSincronizacoes();
          storeSistema.mutations.setSincronizacoes(storeSistema.state, listaSync);
          
          var syncObrig = storeSistema.getters.precisaSincronizar(
            storeSistema.state,
            storeSistema.getters
          );
          
          if (syncObrig) {
            storeSistema.state.loadingApp = false;
            return next("/sincronizar");
          }
        }

        // 4. Verificação de Dispositivo
        if (to.meta.device) {
          if (!to.meta.device.includes(storeSistema.getters.device())) {
            storeSistema.state.loadingApp = false;
            return next(from.path);
          }
        }

        // 5. Verificação de Permissão/Atalho
        if (to.meta.cod && to.meta.cod > 0) {
          if (store.state.sistema.atalhos.findIndex((a) => a.operacao == to.meta.cod) < 0) {
            storeSistema.state.loadingApp = false;
            return next("/");
          }
        }
      }
    } 
    
    // --- ROTA DE LOGIN (COM USUÁRIO JÁ LOGADO) ---
    else if (to.path == "/login" && userLogado) {
      storeSistema.state.loadingApp = false;
      return next("/");
    }

    // --- SUCESSO FINAL ---
    storeSistema.state.loadingApp = false;
    return next();

  } catch (error) {
    // Segurança: Se der erro (ex: banco travado), libera a rota e desliga o loading
    console.error("Erro no Router Guard:", error);
    storeSistema.state.loadingApp = false;
    return next();
  }
});

export default router;